function Speech(){
    return(
        <div>
            Speech
        </div>
    )
}
export default Speech;